import { EstadoRespuestaEnum, obtenerIdEstadoRespuesta } from "../shared/enums/EstadoRespuesta.enum";
import { Nilable } from "../shared/utils/Nullable";

export interface IRespuestaEncuestaEstadoDTO {
    state: string;
    item_count: number;
}

export class RespuestaEncuestaEstadoDTO {
    public estado = EstadoRespuestaEnum.ANSWERED;
    public cantidad = 0;

    constructor(json: Nilable<Partial<IRespuestaEncuestaEstadoDTO>>) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IRespuestaEncuestaEstadoDTO>) {
        if (json.state != null) {
            this.estado = EstadoRespuestaEnum[json.state];
        }
        if (json.item_count != null) {
            this.cantidad = json.item_count;
        }
    }

    public toJSON(): IRespuestaEncuestaEstadoDTO {
        return {
            item_count: this.cantidad,
            state: obtenerIdEstadoRespuesta(this.estado)
        };
    }
}
